// /s/{id}/workbench: a machine's workbench (RFC-057), the share loaded and
// its pane drawn (components/WorkbenchView, which the exam edition's room
// draws too, RFC-062).
import { useEffect, useState } from "react";
import { api, type ShareDetail, type User } from "../api";
import { PageLoading, PageNotice } from "../components/Page";
import { WorkbenchView } from "../components/WorkbenchView";

const errText = (err: unknown) => (err instanceof Error ? err.message : String(err));

/** The loader: the share, then its workbench. */
export function Workbench({ id, me }: { id: string; me: User }) {
  const [share, setShare] = useState<ShareDetail | null>(null);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    api.share(id).then(setShare, (err: unknown) => setError(errText(err)));
  }, [id]);
  if (error) return <PageNotice error={error} />;
  if (!share) return <PageLoading />;
  return <WorkbenchView share={share} me={me} />;
}
